import React, { useState } from 'react'
import { CATALOG_FILTER } from 'lib/core/resources/constants'
import { ReactComponent as Chevron } from 'resources/svg/icons/caret-down.svg'
import { ChangeFilterHandler, FilterOptions, LayeredPriceFilter } from 'lib/modules/catalog'
import { Drops } from 'scenes/Product/components/DescriptionTabs/styled'
import { ReactComponent as DropSvg } from 'resources/svg/icons/drop.svg'

interface Props {
  isFetching: boolean
  filterOptions: FilterOptions
  handleFilterChange: ChangeFilterHandler
}

export const Filter = ({ filterOptions, handleFilterChange, isFetching }: Props) => {
  const {
    code,
    items,
    name,
    selected,
    settings
  } = filterOptions

  const [toggle, setToggle] = useState(Boolean(settings?.collapsed))

  if (!items.length) {
    return null
  }

  const className = toggle ? 'isClosed' : undefined
  const priceRange = (code === CATALOG_FILTER.PRICE && items.length) ? items[0].value.split('-') : undefined
  const isAbsorvencyLevel = code === 'padliner_absorbency' || code === 'underwear_absorbency'

  return (
    <li key={code}>
      <div
        onClick={() => setToggle(toggle => !toggle)}
      >
        <strong>
          <span>{name}</span>
          <Chevron className={className} />
        </strong>
      </div>
      <div className={className}>
        {priceRange ? (
          <LayeredPriceFilter
            minRange={parseInt(priceRange[0])}
            maxRange={parseInt(priceRange[1])}
            isFetching={isFetching}
            onChange={(e) => {
              handleFilterChange({
                requestVar: code,
                value: [e]
              })
            }}
            value={selected?.[0].value}
          />
        ) : (
          <>
            {items.map((item) => {
              const absorvencyLabel = isAbsorvencyLevel ? (item.label as string).split(' ') : undefined
              const label = item.label as string
              return (
                <div key={`f-${item.requestVar}-${item.value}`}>
                  <label>
                    <input
                      type='checkbox'
                      checked={Boolean(selected?.find(el => el.value === item.value))}
                      value={item.value}
                      onChange={(e) => {
                        handleFilterChange({
                          requestVar: item.requestVar,
                          value: [item.value],
                          conf: {
                            multiple: true
                          }
                        })
                      }}
                    />
                    <span>
                      {isAbsorvencyLevel ? (
                        <Drops>
                          {Array.from(Array(parseInt(absorvencyLabel?.[0] as string)).keys()).map(drop => (
                            <DropSvg key={drop} />
                          ))}
                          <span> {absorvencyLabel?.[1].replace(/ *\([^)]*\) */g, '')}</span>
                        </Drops>
                      ) : (
                        <>{label.replace(/ *\([^)]*\) */g, '')}</>
                      )}
                    </span>
                  </label>
                </div>
              )
            })}
          </>
        )}
      </div>
    </li>
  )
}
